module.exports = __webpack_public_path__ + "static/media/biology-virusWarning.08e07244.svg";